// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import HelloController from './hello_controller'
import Sortable from '@stimulus-components/sortable'
import NestedForm from '@stimulus-components/rails-nested-form'

application.register('hello', HelloController)
application.register('sortable', Sortable)
application.register('nested-form', NestedForm)
